import styled, { css } from 'styled-components';

export const ToggleStyled = styled.div<{ value: boolean }>`
  width: 32px;
  height: 16px;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-left: auto;
  border-radius: 8px;
  transition: background-color 300ms;
  ${({ value }) =>
    value
      ? css`
          background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
        `
      : css`
          background-color: ${({ theme }) => theme.kallisto.color.common.black[100]};
        `}
`;

export const ToggleCircle = styled.div<{ value: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: #fff;
  position: absolute;
  box-shadow:
    0px 2px 1px rgb(0 0 0 / 2%),
    0px 2px 6px rgb(0 0 0 / 12%);
  display: flex;
  align-items: center;
  justify-content: center;

  transform: translateX(-2px);
  transition: transform 300ms;
  ${({ value }) =>
    value &&
    css`
      transform: translateX(14px);
    `}
`;

export const ToggleDot = styled.div<{ value: boolean }>`
  width: 6px;
  height: 6px;
  border-radius: 3px;
  transition: background-color 300ms;
`;

export const ToggleContainer = styled.div`
  label > span {
    display: none;
  }
`;
